/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './publication.defs.js'
export { main as default } from './publication.defs.js'
